// extracted by mini-css-extract-plugin
export default {"modalOverlay":"DC-z","modalContent":"EC-z","header":"FC-z","close":"GC-z"};